import React from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';

function EventDetail() {
    useAuthGuard();

    return (
        <Layout>

            Event

        </Layout>
    );
}

export default EventDetail;
